import React from 'react';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';
import Color from '../Color/Color.js';
import Text from '../Text/Text.js';

import { ILegendConfiguration, ILegendItemProps, ILegendProps, ILegendState } from './models/index.js';
import Item from './styledComponents/Item.js';
import ItemColor from './styledComponents/ItemColor.js';
import ItemLabel from './styledComponents/ItemLabel.js';
import ItemValue from './styledComponents/ItemValue.js';
import List from './styledComponents/List.js';
import Wrapper from './styledComponents/Wrapper.js';
import { LEGEND_CATEGORY_KEY, LEGEND_COMPONENT_KEY } from './Legend.meta.js';

export class Legend extends ComponentBase<ILegendProps, ILegendState, ILegendConfiguration> {
	categoryKey = LEGEND_CATEGORY_KEY;
	componentKey = LEGEND_COMPONENT_KEY;

	constructor(props: ILegendProps) {
		super(props);
	}

	item(item: ILegendItemProps, index: number) {
		const { hideValue } = this.props;
		const { label, value, color } = item;
		return (
			<Item key={`legend-item-${index}`}>
				{color && (
					<ItemColor>
						<Color {...color} />
					</ItemColor>
				)}
				{label && (
					<ItemLabel>
						<Text {...label} />
					</ItemLabel>
				)}
				{!hideValue && value && (
					<ItemValue>
						<Text {...value} />
					</ItemValue>
				)}
			</Item>
		);
	}

	render() {
		const { className, items } = this.props;

		if (!items || items.length <= 0) {
			return null;
		}

		return (
			<Wrapper className={className}>
				<List>{items.map((item, index) => this.item(item, index))}</List>
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(observer(Legend), LEGEND_CATEGORY_KEY, LEGEND_COMPONENT_KEY);
